<div class="container">
  @for (lang of selectableLangs | keyvalue; track lang) {
    <div
      class="language-item"
      [class.active]="languageSelected === lang.key"
      (click)="changeLanguage($any(lang.key))">
      <div
        class="lang-image"
        [ngStyle]="{ 'background-image': 'url(/assets/svgs/flags/' + lang.value + '.svg)' }"></div>
    </div>
  }
</div>
